import { render, staticRenderFns } from "./ExportsDataTable.vue?vue&type=template&id=1b94fa00&scoped=true"
import script from "./ExportsDataTable.vue?vue&type=script&lang=js"
export * from "./ExportsDataTable.vue?vue&type=script&lang=js"
import style0 from "./ExportsDataTable.vue?vue&type=style&index=0&id=1b94fa00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b94fa00",
  null
  
)

export default component.exports